export default {
  metaTitle: 'Customized Categories',
  pageTitle: 'Customized Categories',
  addCategory: 'Add a store category',
  categoryName: 'Category name',
  editCategory: 'Edit the category',
  storeCategoryId: 'Store Category ID',
  storeCategoryName: 'Store Category name',
  index: 'Sort Value',
  indexTip: 'The higher the value, the higher the category appears in your store\'s category page.',
  listings: 'Listings',
  operation: 'Operation',
  deleteCategory: 'Delete category',
  nameNot: '未填写名称!',
  addSuccess: '增添成功!',
  duplicateName: '分类名重复',
  editSuccess: '修改成功!',
  deleteComfrim: 'Are you sure to delete it?',
  deleteSuccess: '删除成功!'
}
